import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import AscendTheRanks from "./sections/AscendTheRanks";
import PracticeManagementReimagined from "./sections/PracticeManagementReimagined";
import RealResultsForDelhiClinics from "./sections/RealResultsForDelhiClinics";
import WhyShoppersLoveUs from "./sections/WhyShoppersLoveUs";
import TheCoordinates from "./sections/TheCoordinates";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <AscendTheRanks />
      <PracticeManagementReimagined />
      <RealResultsForDelhiClinics />
      <WhyShoppersLoveUs />
      <TheCoordinates />
      <Footer />
    </div>;
}